import { render, staticRenderFns } from "./MarketingServicesAgreementDeveloper.vue?vue&type=template&id=68bc4b6c&"
import script from "./MarketingServicesAgreementDeveloper.vue?vue&type=script&lang=js&"
export * from "./MarketingServicesAgreementDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./MarketingServicesAgreementDeveloper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports